// home page
export const homeSwitcher_1 = (item, dataTranslate) => {
  const data = dataTranslate.pages.home_p.cards;
  switch (Object.keys(item)[0]) {
    case "debtedCustomers":
      return { key: "debtedCustomers", title: data.card3 };

    case "creditorCustomers":
      return { key: "creditorCustomers", title: data.card4 };

    case "totalCustomers":
      return { key: "totalCustomers", title: data.card1 };

    case "debtorCustomersOutOfLimit":
      return { key: "debtorCustomersOutOfLimit", title: data.card2 };

    default:
  }
};

export const homeSwitcher_2 = (item, dataTranslate) => {
  const data = dataTranslate.pages.home_p.cards;
  switch (Object.keys(item)[0]) {
    case "debtorBalancesWhoReachedLimit":
      return { key: "debtorBalancesWhoReachedLimit", title: data.card6 };

    case "overAllDebtorBalances":
      return { key: "overAllDebtorBalances", title: data.card5 };

    default:
  }
};
// shipping page 
export const shippingSwitcher_1 = (item, dataTranslate) => {
  const data = dataTranslate.pages.shipment_p.cards;
  switch (Object.keys(item)[0]) {
    case "totalShippings":
      return { key: "totalShippings", title: data.card1 };

    case "thisMonthShippings":
      return { key: "thisMonthShippings", title: data.card2 };

    default:
  }
};
// transfers page & tab
export const transfersSwitcher_1 = (item, dataTranslate) => {
  const data = dataTranslate.pages.transfers_p.cards;
  switch (Object.keys(item)[0]) {
    case "totalWithdrawn":
      return { key: "totalWithdrawn", title: data.card1 };

    case "totalNotWithdrawn":
      return { key: "totalNotWithdrawn", title: data.card2 };

    case "totalCanceled":
      return { key: "totalCanceled", title: data.card3 };

    default:
  }
};

export const transfersSwitcher_2 = (item, dataTranslate) => {
  const data = dataTranslate.pages.transfers_p.cards;
  switch (Object.keys(item)[0]) {
    case "totalWithdrawnBalances":
      return { key: "totalWithdrawnBalances", title: data.card6 };

    case "totalNotWithdrawnBalances":
      return { key: "totalNotWithdrawnBalances", title: data.card5 };

    default:
  }
};

// exports tab
export const exportSwitcher_1 = (item, dataTranslate) => {
  const data = dataTranslate.home_tabs.exports_tab.cards;
  switch (Object.keys(item)[0]) {
    case "totalOutgoing":
      return { key: "totalOutgoing", title: data.card1 };

    case "paidOutgoing":
      return { key: "paidOutgoing", title: data.card3 };

    case "notPaidOutgoing":
      return { key: "notPaidOutgoing", title: data.card2 };

    default:
  }
};

export const exportSwitcher_2 = (item, dataTranslate) => {
  const data = dataTranslate.home_tabs.exports_tab.cards;
  switch (Object.keys(item)[0]) {
    case "totalDebtAmount":
      return { key: "totalDebtAmount", title: data.card4 };

    case "totalPaidAmount":
      return { key: "totalPaidAmount", title: data.card5 };

    default:
  }
};

// wallet tab
export const walletSwitcher_1 = (item, dataTranslate) => {
  const data = dataTranslate.home_tabs.wallet_tab.cards;
  switch (Object.keys(item)[0]) {
    case "hot_wallet":
      return { key: "hot_wallet", title: data.card1 };

    case "cold_wallet":
      return { key: "cold_wallet", title: data.card2 };

    default:
  }
};

// wallet tab
export const officeSwitcher_1 = (item, dataTranslate) => {
  const data = dataTranslate.pages.office_p.cards;
  switch (Object.keys(item)[0]) {
    case "all":
      return { key: "all", title: data.card1 };

    case "blocked":
      return { key: "blocked", title: data.card2 };

    default:
  }
};

// shipments tab 
export const shipmentSwitcher_1 = (item, dataTranslate) => {
  const data = dataTranslate.home_tabs.customerShipment_tab.cards;
  switch (Object.keys(item)[0]) {
    case "totalShipments":
      return { key: "totalShipments", title: data.card1 };

    case "paidShipments":
      return { key: "paidShipments", title: data.card3 };

    case "notPaidShipments":
      return { key: "notPaidShipments", title: data.card2 };

    default:
  }
}

export const shipmentSwitcher_2 = (item, dataTranslate) => {
  const data = dataTranslate.home_tabs.customerShipment_tab.cards;
  switch (Object.keys(item)[0]) {
    case "totalDebtAmount":
      return { key: "totalDebtAmount", title: data.card4 };

    case "totalPaidAmount":
      return { key: "totalPaidAmount", title: data.card5 };

    default:
  }
}
